export enum MerlinxLandingTypes {
  FLIGHTS = 'voli',
  HOTEL = 'hotel',
  CAR = 'autonoleggio',
  PARKING = 'parcheggio'
}
